import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse,
} from '@angular/common/http';
import { BehaviorSubject, EMPTY, Observable, throwError, timer } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { catchError, filter, finalize, switchMap, take } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { NgxSpinnerService } from 'ngx-spinner';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable()
export class AuthtokenInterceptor implements HttpInterceptor {
  constructor(
    private authService: AuthService,
    private spinner: NgxSpinnerService,
    private snackBar: MatSnackBar
  ) {}
  private isRefreshing = false;
  private refreshTokenSubject = new BehaviorSubject<any>(null);
  private apiUrl = environment.baseUrl;
  httpRequestCount = 0;
  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    this.httpRequestCount++;

    this.spinner.show();
    const authToken = this.authService.getAuthToken();
    if (authToken && request.url !== `${this.apiUrl}/refresh-token`) {
      request = request.clone({
        headers: request.headers.set('Authorization', `Bearer ${authToken}`),
      });
    }
    return next.handle(request).pipe(
      catchError((error: any) => {
        this.spinner.hide();
        if (error instanceof HttpErrorResponse && error.status === 403) {
          return this.handle401Error(request, next);
        } else return throwError(error);
      }),
      finalize(() => {
        if (this.httpRequestCount !== 0) this.httpRequestCount--;
        if (this.httpRequestCount <= 0) {
          timer(250)
            .pipe(take(1))
            .subscribe(() => {
              this.spinner.hide();
            });
        }
      })
    );
  }

  private handle401Error(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    if (!this.isRefreshing) {
      this.spinner.show();
      this.isRefreshing = true;
      this.refreshTokenSubject.next(null);

      return this.authService.refreshToken().pipe(
        switchMap((token: any) => {
          const jwt = token.headers.get('authorization')?.split(' ')[1];
          this.isRefreshing = false;
          this.refreshTokenSubject.next(jwt);
          const newRequest = request.clone({
            headers: request.headers.set('Authorization', `Bearer ${jwt}`),
          });
          return next.handle(newRequest);
        }),
        catchError((error: any) => {
          if (this.httpRequestCount !== 0) this.httpRequestCount--;
          if (this.httpRequestCount <= 0) {
            timer(250)
              .pipe(take(1))
              .subscribe(() => {
                this.spinner.hide();
              });
          }
          this.snackBar.open('Login expired!, Please login again', '', {
            duration: 3000,
          });
          console.log('error:', error);
          this.authService.logout();
          return EMPTY;
        })
      );
    } else {
      return this.refreshTokenSubject.pipe(
        filter((token) => token != null),
        take(1),
        switchMap((jwt) => {
          const newRequest = request.clone({
            headers: request.headers.set('Authorization', `Bearer ${jwt}`),
          });
          this.spinner.hide();
          return next.handle(newRequest);
        })
      );
    }
  }
}
